(() => {
  const DRAWER_SELECTOR = '.dj-collection-filter-drawer';
  const CANONICAL_COLOR_VALUES = new Map([
    ['Black', 'black'],
    ['Blue', 'blue'],
    ['Bronze', 'bronze'],
    ['Bright pink', 'bright-pink'],
    ['Golden', 'golden'],
    ['Green', 'green'],
    ['Maroon', 'maroon'],
    ['Orange', 'orange'],
    ['Peach', 'peach'],
    ['Pink', 'pink'],
    ['Purple', 'purple'],
    ['Red', 'red'],
    ['Silver', 'silver'],
    ['Violet', 'violet'],
    ['White', 'white'],
    ['Yellow', 'yellow'],
  ]);
  const LOCALIZED_COLOR_TERMS = {
    ru: {
      black: ['черн'],
      blue: ['син'],
      bronze: ['бронз'],
      'bright-pink': ['ярко-роз'],
      golden: ['золот'],
      green: ['зелен'],
      maroon: ['бордов'],
      orange: ['оранж'],
      peach: ['персик'],
      pink: ['розов'],
      purple: ['фиолет'],
      red: ['красн'],
      silver: ['сереб'],
      violet: ['лилов'],
      white: ['бел'],
      yellow: ['желт'],
    },
    ar: {
      black: ['أسود'],
      blue: ['أزرق'],
      bronze: ['برونز'],
      'bright-pink': ['وردي فاقع'],
      golden: ['ذهبي'],
      green: ['أخضر'],
      maroon: ['خمري'],
      orange: ['برتقالي'],
      peach: ['خوخ'],
      pink: ['وردي', 'لون القرنفل'],
      purple: ['أرجواني'],
      red: ['أحمر'],
      silver: ['فضي'],
      violet: ['بنفسجي'],
      white: ['أبيض'],
      yellow: ['أصفر'],
    },
  };
  const LOCALIZED_COLOR_LABELS = {
    ru: {
      black: 'Черный',
      blue: 'Синий',
      bronze: 'Бронзовый',
      'bright-pink': 'Ярко-розовый',
      golden: 'Золотой',
      green: 'Зеленый',
      maroon: 'Бордовый',
      orange: 'Оранжевый',
      peach: 'Персиковый',
      pink: 'Розовый',
      purple: 'Фиолетовый',
      red: 'Красный',
      silver: 'Серебряный',
      violet: 'Лиловый',
      white: 'Белый',
      yellow: 'Желтый',
    },
    ar: {
      black: 'أسود',
      blue: 'أزرق',
      bronze: 'برونزي',
      'bright-pink': 'وردي فاقع',
      golden: 'ذهبي',
      green: 'أخضر',
      maroon: 'خمري',
      orange: 'برتقالي',
      peach: 'خوخي',
      pink: 'وردي',
      purple: 'أرجواني',
      red: 'أحمر',
      silver: 'فضي',
      violet: 'بنفسجي',
      white: 'أبيض',
      yellow: 'أصفر',
    },
  };

  const money = (value) =>
    new Intl.NumberFormat(document.documentElement.lang || 'en', {
      maximumFractionDigits: 0,
    }).format(Math.round(Number(value) || 0));

  const stopAutomaticFiltering = (control) => {
    if (control.dataset.djPendingFilterReady === 'true') return;
    control.dataset.djPendingFilterReady = 'true';
    control.addEventListener('input', (event) => event.stopPropagation());
  };

  const updateAnyState = (details) => {
    const anyLink = details?.querySelector('.dj-filter-any-item a');
    if (!anyLink) return;
    const hasSelection = Array.from(details.querySelectorAll('input[type="checkbox"]')).some(
      (input) => input.checked
    );
    anyLink.classList.toggle('active', !hasSelection);
  };

  const updatePricePresetState = (form) => {
    const minimum = form.querySelector('price-range input[name="filter.v.price.gte"]')?.value || '';
    const maximum = form.querySelector('price-range input[name="filter.v.price.lte"]')?.value || '';

    form.querySelectorAll('.dj-mobile-price-preset').forEach((preset) => {
      preset.classList.toggle(
        'active',
        (preset.dataset.djPriceMin || '') === minimum && (preset.dataset.djPriceMax || '') === maximum
      );
    });
  };

  const initializeRange = (root) => {
    if (root.dataset.djRangeReady === 'true') return;

    const lower = root.querySelector('.dj-price-range__input--min');
    const upper = root.querySelector('.dj-price-range__input--max');
    const current = root.querySelector('[data-dj-price-current]');
    const minimumLabel = root.querySelector('[data-dj-price-min-label]');
    const hiddenMinimum = root.closest('.mobile-facets__submenu')?.querySelector(
      'price-range input[name="filter.v.price.gte"]'
    );
    const hiddenMaximum = root.closest('.mobile-facets__submenu')?.querySelector(
      'price-range input[name="filter.v.price.lte"]'
    );

    if (!lower || !upper || !hiddenMinimum || !hiddenMaximum) return;

    root.dataset.djRangeReady = 'true';

    const render = () => {
      const ceiling = Math.max(1, Number(upper.max) || 1);
      const minValue = Math.min(Number(lower.value), Number(upper.value));
      const maxValue = Math.max(Number(lower.value), Number(upper.value));

      lower.value = String(minValue);
      upper.value = String(maxValue);
      root.style.setProperty('--dj-start', `${(minValue / ceiling) * 100}%`);
      root.style.setProperty('--dj-end', `${(maxValue / ceiling) * 100}%`);

      if (current) current.textContent = `${money(minValue)} - ${money(maxValue)} AED`;
      if (minimumLabel) minimumLabel.textContent = `${money(minValue)} AED`;
    };

    const stagePrice = () => {
      hiddenMinimum.value = Number(lower.value) > 0 ? lower.value : '';
      hiddenMaximum.value = Number(upper.value) < Number(upper.max) ? upper.value : '';
      updatePricePresetState(root.closest('form'));
    };

    root.djRenderPriceRange = render;
    lower.addEventListener('input', () => {
      if (Number(lower.value) > Number(upper.value)) lower.value = upper.value;
      render();
    });
    upper.addEventListener('input', () => {
      if (Number(upper.value) < Number(lower.value)) upper.value = lower.value;
      render();
    });
    lower.addEventListener('change', stagePrice);
    upper.addEventListener('change', stagePrice);
    render();
  };

  const snapshotForm = (form) =>
    Array.from(form.querySelectorAll('input, select')).map((control) => ({
      control,
      checked: 'checked' in control ? control.checked : undefined,
      value: control.value,
    }));

  const restoreSnapshot = (form, snapshot) => {
    if (!snapshot) return;
    snapshot.forEach(({ control, checked, value }) => {
      if (!control.isConnected) return;
      if (checked !== undefined) control.checked = checked;
      control.value = value;
    });
    form.querySelectorAll('[data-dj-price-range]').forEach((range) => range.djRenderPriceRange?.());
    form.querySelectorAll('.dj-filter-group--size, .dj-filter-group--color').forEach(updateAnyState);
    updatePricePresetState(form);
  };

  const clearAllPending = (form) => {
    form.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach((input) => {
      input.checked = false;
    });
    form.querySelectorAll('price-range input').forEach((input) => {
      input.value = '';
    });
    form.querySelectorAll('[data-dj-price-range]').forEach((range) => {
      const lower = range.querySelector('.dj-price-range__input--min');
      const upper = range.querySelector('.dj-price-range__input--max');
      if (lower) lower.value = lower.min || '0';
      if (upper) upper.value = upper.max;
      range.djRenderPriceRange?.();
    });
    form.querySelectorAll('.dj-filter-group--size, .dj-filter-group--color').forEach(updateAnyState);
    updatePricePresetState(form);
  };

  const localizedColorKeys = (value, locale, terms) => {
    let normalized = value.toLocaleLowerCase(locale);
    if (locale === 'ru') normalized = normalized.replaceAll('ё', 'е');

    const keys = Object.entries(terms)
      .filter(([, needles]) => needles.some((needle) => normalized.includes(needle)))
      .map(([key]) => key);

    if (keys.includes('bright-pink')) {
      const pinkIndex = keys.indexOf('pink');
      if (pinkIndex !== -1) keys.splice(pinkIndex, 1);
    }

    return keys;
  };

  const ensureLocalizedCanonicalColorOptions = (form) => {
    const locale = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
    const terms = LOCALIZED_COLOR_TERMS[locale];
    const labels = LOCALIZED_COLOR_LABELS[locale];
    if (!terms || !labels) return;

    const parameterName = 'filter.p.m.custom.color_filter';
    const submittedValues = new URL(window.location.href).searchParams.getAll(parameterName);

    form.querySelectorAll('.dj-filter-group--color .mobile-facets__list').forEach((list, listIndex) => {
      const inputs = Array.from(list.querySelectorAll(`input[type="checkbox"][name="${parameterName}"]`));
      const aliasInputs = inputs.filter((input) => !CANONICAL_COLOR_VALUES.has(input.value));
      const existingValues = new Set(inputs.map((input) => input.value));

      CANONICAL_COLOR_VALUES.forEach((key, value) => {
        if (existingValues.has(value)) return;
        const hasLocalizedProducts = aliasInputs.some((input) =>
          localizedColorKeys(input.value, locale, terms).includes(key)
        );
        if (!hasLocalizedProducts) return;

        const item = document.createElement('li');
        item.className = 'mobile-facets__item list-menu__item dj-generated-canonical-color';

        const label = document.createElement('label');
        label.className = `facets__label mobile-facets__label dj-mobile-color-label dj-color-${key} dj-color-canonical`;

        const input = document.createElement('input');
        input.className = 'mobile-facets__checkbox';
        input.type = 'checkbox';
        input.name = parameterName;
        input.value = value;
        input.id = `Filter-${parameterName}-mobile-generated-${listIndex}-${key}`;
        input.checked = submittedValues.includes(value);
        label.htmlFor = input.id;

        const highlight = document.createElement('span');
        highlight.className = 'mobile-facets__highlight';

        const visible = document.createElement('span');
        visible.className = 'facet-checkbox__text';
        visible.setAttribute('aria-hidden', 'true');
        const visibleLabel = document.createElement('span');
        visibleLabel.className = 'facet-checkbox__text-label';
        visibleLabel.textContent = labels[key];
        visible.append(visibleLabel);

        const accessible = document.createElement('span');
        accessible.className = 'visually-hidden';
        accessible.textContent = labels[key];

        label.append(input, highlight, visible, accessible);
        item.append(label);
        list.append(item);
      });

      /* FIX: only touch the DOM if the order genuinely needs to change.
         list.append(item) on a node that is already the last-appended child
         still fires a childList mutation, which the MutationObserver below
         picks up and reacts to — running this unconditionally caused an
         infinite reorder -> mutation -> reorder loop on ru/ar locales
         (the only locales where this function does any work at all). */
      const canonicalOrder = Array.from(CANONICAL_COLOR_VALUES.keys());
      const canonicalItemsInCurrentOrder = Array.from(
        list.querySelectorAll('.dj-mobile-color-label.dj-color-canonical')
      )
        .map((label) => label.closest('li'))
        .filter(Boolean);

      const sortedItems = [...canonicalItemsInCurrentOrder].sort((left, right) => {
        const leftValue = left.querySelector(`input[name="${parameterName}"]`)?.value;
        const rightValue = right.querySelector(`input[name="${parameterName}"]`)?.value;
        return canonicalOrder.indexOf(leftValue) - canonicalOrder.indexOf(rightValue);
      });

      const alreadyInOrder = sortedItems.every((item, index) => item === canonicalItemsInCurrentOrder[index]);
      if (!alreadyInOrder) {
        sortedItems.forEach((item) => list.append(item));
      }
    });
  };

  const syncLocalizedColorAliases = (form) => {
    const locale = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
    const terms = LOCALIZED_COLOR_TERMS[locale];
    if (!terms) return;

    const inputs = Array.from(
      form.querySelectorAll('input[type="checkbox"][name="filter.p.m.custom.color_filter"]')
    );
    const selectedKeys = new Set(
      inputs
        .filter((input) => CANONICAL_COLOR_VALUES.has(input.value) && input.checked)
        .map((input) => CANONICAL_COLOR_VALUES.get(input.value))
    );

    inputs
      .filter((input) => !CANONICAL_COLOR_VALUES.has(input.value))
      .forEach((input) => {
        const aliasKeys = localizedColorKeys(input.value, locale, terms);

        input.checked = aliasKeys.some((key) => selectedKeys.has(key));
      });
  };

  const expandLocalizedColorAliasesInUrl = (form) => {
    const locale = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
    if (!LOCALIZED_COLOR_TERMS[locale]) return false;

    const parameterName = 'filter.p.m.custom.color_filter';
    const destination = new URL(window.location.href);
    const currentValues = destination.searchParams.getAll(parameterName);
    const hasSubmittedCanonicalSelection = currentValues.some((value) =>
      CANONICAL_COLOR_VALUES.has(value)
    );
    if (!hasSubmittedCanonicalSelection) return false;

    const colorInputs = Array.from(
      form.querySelectorAll(`input[type="checkbox"][name="${parameterName}"]`)
    );
    const hasCanonicalSelection = colorInputs.some(
      (input) => CANONICAL_COLOR_VALUES.has(input.value) && input.checked
    );
    if (!hasCanonicalSelection) return false;

    syncLocalizedColorAliases(form);
    const desiredValues = colorInputs.filter((input) => input.checked).map((input) => input.value);
    const normalizedCurrent = [...currentValues].sort().join('\u0000');
    const normalizedDesired = [...desiredValues].sort().join('\u0000');
    if (normalizedCurrent === normalizedDesired) return false;

    destination.searchParams.delete(parameterName);
    desiredValues.forEach((value) => destination.searchParams.append(parameterName, value));
    destination.hash = '';
    window.location.replace(destination.toString());
    return true;
  };

  const applyPendingFilters = (form, drawerDetails) => {
    syncLocalizedColorAliases(form);
    const params = new URLSearchParams();
    new FormData(form).forEach((value, name) => {
      if (String(value).trim() !== '') params.append(name, value);
    });

    drawerDetails.dataset.djApplyingFilters = 'true';
    const destination = new URL(window.location.href);
    destination.search = params.toString();
    destination.hash = '';
    window.location.assign(destination.toString());
  };

  const initializeDrawer = (drawer) => {
    const form = drawer.querySelector('#FacetFiltersFormMobile');
    const drawerDetails = drawer.querySelector(':scope > details');
    if (!form || !drawerDetails) return;

    ensureLocalizedCanonicalColorOptions(form);
    form.querySelectorAll('input, select').forEach(stopAutomaticFiltering);
    form.querySelectorAll('[data-dj-price-range]').forEach(initializeRange);
    form.querySelectorAll('.dj-filter-group--size, .dj-filter-group--color').forEach(updateAnyState);
    updatePricePresetState(form);
    if (expandLocalizedColorAliasesInUrl(form)) return;

    if (drawer.dataset.djPendingFiltersReady === 'true') return;
    drawer.dataset.djPendingFiltersReady = 'true';

    drawerDetails.addEventListener('toggle', () => {
      if (drawerDetails.open) {
        drawerDetails.djCommittedFilterState = snapshotForm(form);
        delete drawerDetails.dataset.djApplyingFilters;
      } else if (drawerDetails.dataset.djApplyingFilters !== 'true') {
        restoreSnapshot(form, drawerDetails.djCommittedFilterState);
      }
    });

    form.addEventListener('change', (event) => {
      const details = event.target.closest('.dj-filter-group--size, .dj-filter-group--color');
      if (details) updateAnyState(details);
    });

    form.addEventListener('click', (event) => {
      const applyButton = event.target.closest('[data-dj-filter-apply]');
      if (applyButton) {
        event.preventDefault();
        applyPendingFilters(form, drawerDetails);
        return;
      }

      const clearAll = event.target.closest('[data-dj-filter-clear-all]');
      if (clearAll) {
        event.preventDefault();
        clearAllPending(form);
        return;
      }

      const clearGroup = event.target.closest('[data-dj-filter-clear-group], .dj-filter-any-item a');
      if (clearGroup) {
        event.preventDefault();
        const details = clearGroup.closest('.mobile-facets__details');
        details?.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach((input) => {
          input.checked = false;
        });
        updateAnyState(details);
        return;
      }

      const preset = event.target.closest('.dj-mobile-price-preset[data-dj-price-min]');
      if (preset) {
        event.preventDefault();
        const minimum = form.querySelector('price-range input[name="filter.v.price.gte"]');
        const maximum = form.querySelector('price-range input[name="filter.v.price.lte"]');
        const range = form.querySelector('[data-dj-price-range]');
        const lower = range?.querySelector('.dj-price-range__input--min');
        const upper = range?.querySelector('.dj-price-range__input--max');

        if (minimum) minimum.value = preset.dataset.djPriceMin || '';
        if (maximum) maximum.value = preset.dataset.djPriceMax || '';
        if (lower) lower.value = preset.dataset.djPriceMin || lower.min || '0';
        if (upper) upper.value = preset.dataset.djPriceMax || upper.max;
        range?.djRenderPriceRange?.();
        updatePricePresetState(form);
      }
    });
  };

  const initializeAll = () => {
    document.querySelectorAll(DRAWER_SELECTOR).forEach(initializeDrawer);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }

  /* FIX: disconnect the observer while initializeAll() runs (it can itself
     mutate the DOM), then reconnect afterwards. This is the standard-safe
     pattern for an observer whose own callback may touch the tree it
     watches, and is a defense-in-depth backstop on top of the fix above. */
  const canonicalColorObserver = new MutationObserver(() => {
    canonicalColorObserver.disconnect();
    initializeAll();
    canonicalColorObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  });
  canonicalColorObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();